import React, { useEffect, useState } from "react";
import {Redirect} from "react-router-dom";
import PopupMessage from "../components/PopupMessage";
import auth from '../../../service/Auth';
import { downloadCSV } from '../../../service/CsvButton';
import { asperafilesinformation } from '../../../service/apis';
import TableView from "../components/TableView";

const config = window.config;


const headers = [
    {label: "File Name", key: "file_name", tooltip: "File found at Aspera Shares Folder."},
    {label: "Experiment", key: "experiment", tooltip: "Experiment ID."},
    {label: "Experiment Submitter", key: "experiment_submitter", tooltip: "Experiment submitter user mail."},
    {label: "Experiment Owner", key: "experiment_owner", tooltip: "Group Owner of the experiment associated to the file."},
    {label: "Experiment Strategy", key: "experiment_strategy", tooltip: "Type of experiment."},
    {label: "Experiment Platform", key: "experiment_in_platform", tooltip: "Is experiment already uploaded to the GPAP platform."},
    {label: "Experiment Processed", key: "experiment_processed", tooltip: "Is experiment completely processed. SNP calling done."},
    {label: "Experiment File Submission Closed", key: "experiment_file_submission_close", tooltip: "Has the experiment owner close the file submission?" }
];


const AsperaInfo = (props) =>{

    const [data, setData] = useState({});
    const [errors, setErrors] = useState("");
    const [loading, setLoading] =  useState(true);
    const [goBack, setGoBack] =  useState(false);
    const [title, setTitle] = useState("");
    const [asperaExperiments, setAsperaExperiments] = useState(false);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    
    const fetchData = async (body) => {
        await asperafilesinformation(auth.getToken(),config.api_endpoint,JSON.stringify(body))
        .then((response) => {
            return response.json()
        })
        .then((data) => {
            setData(data);
            setTitle("Files found at " + props.location.share + " Aspera Shares folder");
            setLoading(false);
        });
    }
    
    useEffect(() => {
        // 1. Logging Check
        if (auth.tokenExpired()) {
            setErrors("Logging session timeout. Please log again");
        }
        else if (!auth.isUserAdmin()) {
            setErrors("User does not have admin permissions.");
        }
        else if (props.location.data === undefined) {
            let body = {"aspera_files": props.location.apiInfo[props.location.share].files};
            fetchData(body);
        }
    },[])
    
    const updateColumns = () => {
        let cols = []
        for (let header of headers) {
              let col = {};
              col["Header"] =  props => <span title={header.tooltip}>{header.label} <i className="fa fa-comment-o" aria-hidden="true"></i></span>;
              col["accessor"] = header.key;
              col["minWidth"] = 220;
              cols.push(col);
        }
        setColumns(cols);
    }
    
    const updateRows = () => {
        let tableRows = [];
        for (let index in data) {
            let rowTable = {};
            let fileInfo = data[index];
            //1. Loop Headers
            for (let column of columns){
                let value = fileInfo[column.accessor];
                if (typeof value === "boolean") rowTable[column.accessor] = value.toString();
                else rowTable[column.accessor] = value;
            }
            //2. Add row to data
            tableRows.push(rowTable);
        }
        // 3. Update Rows
        setRows(tableRows);
    }
    
    useEffect(() => {
        // 1. Update Table Columns
        updateColumns(); 
        // 2. Update Rows with the updated data memeber
        updateRows();
    },[data])
    
    const goBackButton = (event) => {
        setGoBack(true);     
    }
    
    const getCsvData = (events) => {
      // Handler to get CSV Data
      let today = new Date().toISOString().slice(0, 10);
      downloadCSV(rows,headers,`${today}_aspera_info.csv`);
    }
    
    /*Show popup in case an error with the loggin occurs*/
    if (errors !== "") {
        return <PopupMessage title={"Logging error!"} message={errors} href={"#/admin"} />;
    }
    else if(goBack) {
        return <Redirect to={{pathname:'/admin/aspera',data:props.location.apiInfo}} />
    }
    else if(asperaExperiments) {
         return <Redirect to={{pathname:'/admin/asperaexperimentsinfo', data:data, apiInfo:props.location.apiInfo,
                                 share:props.location.share, type: props.location.type }}/>;
    }
    else {
        return (
            <TableView 
                title = {title}
                goBack = {goBackButton}
                getCsvData = {getCsvData}
                rows = {rows}
                columns = {columns}
                height = {700}
                loading = {loading}
            />
        );
    }    
} 
 
export default AsperaInfo;